import {formsStore} from '../../../stores/Form/FormsStore';

export function getDecimalSign(): string {
    if (formsStore.sysConstants?.decimalsign) {
        return formsStore.sysConstants.decimalsign.Str;
    }
    return '.';
}

export function getThousandSign(): string {
    if (formsStore.sysConstants?.thousandsign) {
        return formsStore.sysConstants.thousandsign.Str;
    }
    return ',';
}

export const cleanThousandSigns = (value: string) => {
    const thousandSign = getThousandSign();
    const regEx = new RegExp(thousandSign, 'g');
    return value.replace(regEx, '');
};

export function countDecimals(value: number): number {
    if (Math.floor(value) !== value) return value.toString().split('.')[1].length;
    return 0;
}

export function formatNumber(
    value: string,
    minimumFractionDigits = 0,
    thousandSign: string = getThousandSign(),
    decimalSign: string = getDecimalSign()
) {
    if (value == null || value === '') {
        return value;
    }
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSign);
    if (minimumFractionDigits) {
        if (!parts[1]) {
            parts[1] = '0'.repeat(minimumFractionDigits);
        } else if (parts[1].length < minimumFractionDigits) {
            parts[1] = parts[1] + '0'.repeat(minimumFractionDigits - parts[1].length);
        }
    }

    return parts.join(decimalSign);
}

export const getMaxNumberLength = ({maxLength, decimal}: {maxLength: number; decimal: number}) => {
    let max = maxLength;
    let integralPartlength = maxLength;
    if (decimal) {
        max = max - 1;
        integralPartlength = integralPartlength - decimal - 1;
    }
    const numberOfCommas = Math.floor(integralPartlength / 4);
    return max - numberOfCommas;
};
